import { LoadingContainer } from 'components/loadingContainer'
import { LocalSelling } from 'features/admin/Ticket'
import { useEventByIdForSeats } from 'hooks/admin/useEvents'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

export const LocalTicketSellingPage = () => {
    const { id } = useParams<{ id?: string }>()
    const { data, isLoading, error } = useEventByIdForSeats(id || '')
    const navigate = useNavigate()

    useEffect(() => {
        if (id && !data && !isLoading) navigate('/hiba/404')
    }, [id, data, isLoading, navigate])

    return (
        <LoadingContainer isLoading={isLoading} error={error}>
            <meta name="robots" content="noindex, nofollow" />
            {data && <LocalSelling currentEvent={data} />}
        </LoadingContainer>
    )
}
